<template>
    <div>
        <template v-if="expense_payments === true && expenses != null">
            <div class="clearfix">
                <div class="page-top dropdown mb-1 mb-3 clearfix">
                    <h1 v-if="expenses.expense_name !=''" class="float-left"><span class="highlight-color">{{expenses.expense_name}}</span></h1>
                </div>
                <div class="batch-process-history mb-3">
                    <div class="batch-process-outer" v-if="expenses != null">
                        <div class="batch-process-inner created-by">
                            <span class="action-by"> Requested By </span>
                            <div class="process-content">
                                <div class="user">
                                    <img :src="'/images/table-dummy-image.jpg'" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" title="username"> {{expenses.name}} </strong>
                                </p>
                            </div>
                            <div class="created-date text-right"> Rs. {{expenses.expense_requested_amount | formatAmount}}  </div>
                        </div>
                    </div>
                    <div class="batch-process-outer" v-if="expense_maker != null">
                        <div class="batch-process-inner checked-by">
                            <span class="action-by"> Approved By </span>
                            <div class="process-content">
                                <div class="user">
                                    <img :src="'/images/table-dummy-image.jpg'" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" title="username"> {{expense_maker.name}} </strong> Maker
                                </p>
                            </div>
                            <div class="created-date text-right"> Rs. {{expense_maker.maker_approved_amount | formatAmount}}  </div>
                        </div>
                    </div>
                    <div class="batch-process-outer" v-if="expense_checker != null">
                        <div class="batch-process-inner checked-by">
                            <span class="action-by"> Approved By </span>
                            <div class="process-content">
                                <div class="user">
                                    <img :src="'/images/table-dummy-image.jpg'" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" title="username"> {{expense_checker.name}} </strong> Checker
                                </p>
                            </div>
                            <div class="created-date text-right"> Rs. {{expense_checker.checker_approved_amount | formatAmount}}  </div>
                        </div>
                    </div>
                    <div class="batch-process-outer" v-if="expense_approver != null">
                        <div class="batch-process-inner approved-by">
                            <span class="action-by"> Approved By </span>
                            <div class="process-content">
                                <div class="user">
                                    <img :src="'/images/table-dummy-image.jpg'" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" title="username"> {{expense_approver.name}} </strong> Approver
                                </p>
                            </div>
                            <div class="created-date text-right"> Rs. {{expense_approver.approver_approved_amount | formatAmount}}  </div>
                        </div>
                    </div>
                    <div class="batch-process-outer" v-if="expense_singleowner != null">
                        <div class="batch-process-inner approved-by">
                            <span class="action-by"> Approved By </span>
                            <div class="process-content">
                                <div class="user">
                                    <img :src="'/images/table-dummy-image.jpg'" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" title="username"> {{expense_singleowner.name}} </strong> Single Owner
                                </p>
                            </div>
                            <div class="created-date text-right"> Rs. {{expense_singleowner.singleowner_approved_amount | formatAmount}}  </div>
                        </div>
                    </div>
                </div>
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left">Expense Receipts </h1>
                    <div class="searching float-right mr-2">
                        <input id="customSearch" type="text" class="form-control search" name="" />
                    </div>
                </div>
                <table id="expenseReceiptsTable" class="table" width="100%">
                    <thead>
                        <tr>
                            <th>Transaction ID</th>
                            <th>Category</th>
                            <th>Amount</th>
                            <th>Receipt</th>
                        </tr>
                    </thead>
                </table>
            </div>
        </template>
        <template v-else-if="expense_payments === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="expense_payments === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var gthat = null;
    export default {
        data() {
            return {
                data : null,
                expense_payments: null,
                expenses: [],
				expense_maker: {
					name: "",
					designation_name: "",
					maker_comment: "",
					maker_approved_amount: "",
				},
				expense_checker: {
					name: "",
					designation_name: "",
					checker_comment: "",
					checker_approved_amount: "",
				},
				expense_approver: {
					name: "",
					designation_name: "",
					approver_comment: "",
					approver_approved_amount: "",
				},
                expense_singleowner: {
					name: "",
					designation_name: "",
					singleowner_comment: "",
					singleowner_approved_amount: "",
				},
            };
        },
        mounted() {
            gthat = this;
            this.$Progress.start();
            this.can('expense_payments').then(result => {
                this.expense_payments = result.expense_payments;
            }).then(result => {
                if(this.expense_payments == true){
                    this.detailsToMakerCheckerApprover();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            detailsToMakerCheckerApprover(){
                axios.get('/api/eMoney/detailsToMakerCheckerApprover/'+this.$route.params.id)
				.then(res => {
                    this.viewAllReceipts();
					this.expenses = res.data.expenses;
					this.expense_maker = res.data.expense_maker;
					this.expense_checker = res.data.expense_checker;
					this.expense_approver = res.data.expense_approver;
                    this.expense_singleowner = res.data.expense_singleowner;

					if (res.data.expenses.expense_maker !== null){
						let json_parse_maker = JSON.parse(res.data.expenses.expense_maker);
						this.expense_maker.maker_comment = json_parse_maker.maker_comment;
						this.expense_maker.maker_approved_amount= json_parse_maker.maker_approved_amount;
					}
					if (res.data.expenses.expense_checker !== null){
						let json_parse_checker = JSON.parse(res.data.expenses.expense_checker);
						this.expense_checker.checker_comment = json_parse_checker.checker_comment;
						this.expense_checker.checker_approved_amount= json_parse_checker.checker_approved_amount;
					}
					if (res.data.expenses.expense_approver !== null){
						let json_parse_approver = JSON.parse(res.data.expenses.expense_approver);
						this.expense_approver.approver_comment = json_parse_approver.approver_comment;
						this.expense_approver.approver_approved_amount= json_parse_approver.approver_approved_amount;
					}
                    if (res.data.expenses.expense_singleowner !== null){
						let json_parse_singleowner = JSON.parse(res.data.expenses.expense_singleowner);
						this.expense_singleowner.singleowner_comment = json_parse_singleowner.singleowner_comment;
						this.expense_singleowner.singleowner_approved_amount= json_parse_singleowner.singleowner_approved_amount;
					}
				})
				.catch(err => {
					console.log(err);
					this.showAlertBox('error','some error in data');
				});
            },
			viewAllReceipts(){
                var that = this;
                var expenseReceiptsTable = $('#expenseReceiptsTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "/api/eMoney/viewAllReceipts/"+this.$route.params.id,
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records"
                    },
                    deferRender: true,
                    columns: [
                        {data: 'expense_trasaction_id'},
						{data: 'category_title'},
                        {
                            name: "expense_amount",
                            mData: "expense_amount",
                            render: $.fn.dataTable.render.number(",")
                        },
                        {
                            data: "id",
                            sorting: false,
                            render: function(data, type, full) {
                                var expense_receipt = full["expense_receipt"];
                                var receipt = ""
                                if(expense_receipt != ""){
                                    receipt = "<img src='"+expense_receipt+"' alt='Expense Receipt' width='150'>"
                                }
                                return (
                                    receipt
                                );
                            },
                        }
                    ],
                    drawCallback: function(settings){
                        $(".action").tooltip();
                    },
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 3 ]
                    }],
                    "initComplete": (settings, json) => {
                        this.$Progress.finish();                        
                    }
                });
                $('#customSearch').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        expenseReceiptsTable.search(this.value).draw();
                    }
                });
            }
        }
    }
</script>
